import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import CalendarEvents from '../../pages/markets/component/calendar-events';

export const CalenderEventsWidget = () => {
  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <CalendarEvents widget={true} />
    </QueryClientProvider>
  );
};
